/*
  Campaign capture.

  Stores the utm_* parameters of the current URL in a cookie so they survive the
  navigation between the landing page and /account/register, where the register
  form reads them back into hidden fields.

  Last non-direct touch wins: the cookie is only rewritten when a URL carries at
  least one utm_ parameter, so an internal click-through does not erase it.
*/
(function () {
  var COOKIE_NAME = 'dgm_utm';
  var MAX_AGE_DAYS = 30;
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  /* Commas separate Shopify tags and quotes break segment queries, so drop them. */
  function clean(value) {
    return String(value || '')
      .replace(/[,"']/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 60);
  }

  function readFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var data = {};
    KEYS.forEach(function (key) {
      var value = clean(params.get(key));
      if (value) data[key] = value;
    });
    return data;
  }

  function readFromCookie() {
    var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
    if (!match) return {};
    try {
      return JSON.parse(decodeURIComponent(match[1])) || {};
    } catch (error) {
      return {};
    }
  }

  function writeCookie(data) {
    var expires = new Date(new Date().getTime() + MAX_AGE_DAYS * 86400000).toUTCString();
    document.cookie =
      COOKIE_NAME +
      '=' +
      encodeURIComponent(JSON.stringify(data)) +
      '; expires=' +
      expires +
      '; path=/; SameSite=Lax';
  }

  var current = readFromUrl();
  if (Object.keys(current).length) writeCookie(current);

  window.DGMCampaign = {
    keys: KEYS,
    clean: clean,
    /* utm_* of this visit, falling back to the stored campaign. */
    get: function () {
      return Object.keys(current).length ? current : readFromCookie();
    },
    /*
      "utm_source:google,utm_campaign:ramadan" — ready for customer[tags].
      `extra` adds non-utm pairs to the same list, e.g. {referral: 'abc123'}.
    */
    toTags: function (extra) {
      var data = this.get();
      var pairs = {};

      KEYS.forEach(function (key) {
        pairs[key] = data[key];
      });
      Object.keys(extra || {}).forEach(function (key) {
        pairs[key] = extra[key];
      });

      return Object.keys(pairs)
        .filter(function (key) {
          return clean(pairs[key]);
        })
        .map(function (key) {
          return key + ':' + clean(pairs[key]);
        })
        .join(',');
    },
  };
})();
